import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useServerDataTable } from '@app/components/data-table/hooks/use-server-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import { PaginatedGroupCompanyReportListList } from '@shared/api/types';
import { useGroupCompanyReportsColumns } from './group-company-reports-table-columns';

interface GroupCompanyReportsTableProps
  extends DataTableProps<PaginatedGroupCompanyReportListList> {
  pageCount: number;
}

export default function GroupCompanyReportsTable({
  data,
  status,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  pageCount,
}: GroupCompanyReportsTableProps) {
  const { table, context } = useServerDataTable({
    data: data?.results ?? [],
    columns: useGroupCompanyReportsColumns(),
    pageCount,
    getRowId: (row) => row.uuid,
    initialState: {
      columnVisibility: { uuid: false },
    },
  });

  return (
    <DataTable
      table={table}
      context={context}
      className="bg-gray-00"
      isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
      tableLoading={!data && status === 'loading'}
    >
      <DataTableToolbar table={table} />
    </DataTable>
  );
}
